(function () {
// Events listing page JavaScript

jQuery(document).ready(function($) {
// console.log('Events listing page loaded');
//
// // Filter events by category (if needed)
// $('.event-category-filter').on('click', function(e) {
//     e.preventDefault();
//     // Add your filter logic here
// });
//
// // Add animation on scroll for event items
// const observerOptions = {
//     threshold: 0.1,
//     rootMargin: '0px 0px -50px 0px'
// };
//
// const observer = new IntersectionObserver(function(entries) {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             entry.target.classList.add('fade-in-up');
//             observer.unobserve(entry.target);
//         }
//     });
// }, observerOptions);
//
// // Observe all event items
// document.querySelectorAll('.event-item').forEach(item => {
//     observer.observe(item);
// });
});

})();
//# sourceMappingURL=page-events-listing.js.map
